import { AnyAri } from '@atlassian/ari/any-ari';

import type { SelectFilterState } from '../../../../../common/constants/filters/select-filter/types';
import { ProductKeys } from '../../../../../common/constants/product-keys';

const projectIdToARI = (cloudId: string, projectId: string) =>
	`ari:cloud:jira:${cloudId}:project/${projectId}`;

export const generateQueryParamsGetState = <ID extends string>(
	initialState: SelectFilterState<ID>,
	queryParamKey: string,
) => {
	return (queryParams: Record<string, string[]>, cloudId: string): SelectFilterState<ID> => {
		const selectedProduct = (queryParams['product'] ?? [])[0];
		const queryParamValue = queryParams[queryParamKey] || [];
		// Query params hold ARIs. Links predating that hold bare project ids, which can only be
		// resolved against the current site here.
		// TODO QS-10359: drop the bare id branch once pre-ARI links have aged out. Note this
		// outlives the multi-site rollout, since the ARI format is ungated.
		const value =
			selectedProduct === ProductKeys.JiraDC || selectedProduct === ProductKeys.JsmDC
				? queryParamValue
				: queryParamValue.map((entry) =>
						AnyAri.check(entry) ? entry : projectIdToARI(cloudId || '', entry),
					);

		return {
			...initialState,
			value: value || initialState.value,
		};
	};
};
